"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.theme = void 0;
const common = {
  line: {
    style: {
      data: {
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeWidth: 1
      }
    }
  }
};
const indeterminate = { ...common,
  color: 'text.2',
  colorDeposit: 'ui3'
};
const positive = { ...common,
  color: 'data.positive',
  colorDeposit: 'ui3'
};
const negative = { ...common,
  color: 'data.negative',
  colorDeposit: 'ui3'
};
const theme = {
  indeterminate,
  negative,
  positive
};
exports.theme = theme;
//# sourceMappingURL=LineGraph.theme.js.map